module.exports = __webpack_public_path__ + "files/1f22df60639ee29ab2e81d771c649b81.png";